import { html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html';
import componentStyles from './search-result-card.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class SearchResultCard extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      /**
       * Main content area title
       */
      title: { type: String },
      /**
       * Taxonomy Term above title
       */
      eyebrow: { type: String },
      /**
       * Main content area text below title
       */
      bodyText: { type: String },
      /**
       * Title url
       */
      url: { type: String },
      /**
       * Opens links in a new tab
       */
      target: { type: String },
    };
  }

  constructor() {
    super();
    this.eyebrow = ''
    this.target = '_top'
  }

  render() {
    return html`
      <div class="search-result-card">
        <div class="search-result-card__wrapper">
          <hf-link
            ignoreExternalUrl
            target="${this.target}"
            href="${this.url}"
            styleclass="block">
            ${this.eyebrow.length > 0
              ? html`<hf-heading
                  level=""
                  levelStyle="eyebrow-small"
                  class="search-result-card__label-small"
                >
                  ${unsafeHTML(this.eyebrow)}
                </hf-heading>`
              : nothing}

            <hf-heading
              level="5"
              levelStyle="heading5"
              class="search-result-card__title"
            >
              ${unsafeHTML(this.title)}
            </hf-heading>
            <div class="search-result-card__content-wrapper">
              <hf-wysiwyg
                class="search-result-card__body"
                markup="${this.bodyText}"
              ></hf-wysiwyg>
            </div>
          </hf-link>
        </div>
      </div>
    `;
  }
}
customElements.define('hf-search-result-card', SearchResultCard);
